import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../../common/manipurCommon/FunctionCalls";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
    onSelectChange: (name: string, option: any) => void;
}

const Palpation: React.FC<Props> = ({ formData, onChange, onSelectChange }) => {

    const [athleteList, setAthleteList] = useState<any[]>([]);

    useEffect(() => {
        fetchAthlete();
    }, []);

    async function fetchAthlete() {
        const response = await func.listActiveAthletes();
        setAthleteList(Array.isArray(response) ? response : [])
    }

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    return (
        <>
            <h5 className="text-center">Palpation</h5>
            <div className="row">
                <div className="col-lg-6 mb-10">
                    <div className="input-space">
                        <label className="form-label">Athlete</label>
                        <Select
                            name="athleteId"
                            value={athleteList.find(athlt => athlt.userId === formData.athleteId) ? {
                                value: formData.athleteId,
                                label: athleteList.find(athlt => athlt.userId === formData.athleteId).athleteName
                            } : null}
                            // onChange={onSelectChange}
                            onChange={(option) => onSelectChange("athleteId", option)}
                            styles={customSelect}
                            required
                            placeholder="Select Athlete"
                            options={athleteList.map(athlt => ({
                                value: athlt.userId,
                                label: athlt.athleteName
                            }))}>
                        </Select>
                    </div>
                </div>
                <div className="col-lg-6 mb-10">
                    <div className="input-space">
                        <label className="form-label">Date Of Assessment</label>
                        <input
                            type="date"
                            className="form-control"
                            required
                            name="assessment_date"
                            value={formData.assessment_date}
                            onChange={onChange}
                            placeholder="Enter Date of Assessment" />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6 mb-10">
                    <div className="input-space">
                        <label className="form-label">Right</label>
                        <input
                            type="text"
                            className="form-control"
                            name="palpation_right"
                            value={formData.palpation_right}
                            onChange={onChange}
                            placeholder="Enter Right Value " />
                    </div>
                </div>
                <div className="col-lg-6 mb-10">
                    <div className="input-space">
                        <label className="form-label">Left</label>
                        <input
                            type="text"
                            className="form-control"
                            name="palpation_left"
                            value={formData.palpation_left}
                            onChange={onChange}
                            placeholder="Enter Left Value" />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Palpation;